import React from "react";
import { Link, useHistory } from "react-router-dom";

function NoworkSpaceFound(props) {
  const history = useHistory();

  return (
    <React.Fragment>
      <div className="container">
        <div className="row">&nbsp;</div>
        <div className="row">&nbsp;</div>
        <div className="alert alert-danger bg-white" role="alert">
          <h4 className="alert-heading">No Workspace found!</h4>
          <p>
            Looks like we are unable to find a workspace for you or there is no
            worspace created or assignted to you yet.
          </p>
          <hr />
          <p className="mb-0">
            If you are the admin , Please visit admin section and enable few
            workspaces. Please click&nbsp;
            <Link
              to="#"
              style={{ cursor: "pointer" }}
              onClick={() => history.push("admin/dashboard")}
            >
              here
            </Link>
            &nbsp;to got to admin side
          </p>
          <br />
          <p className="mb-0">
            If you are lost , Please click&nbsp;
            <a href="/login">here</a>&nbsp;to login back
          </p>
        </div>
      </div>
    </React.Fragment>
  );
}

export default NoworkSpaceFound;
